import FilterBottomSheetWrapper from "@features/library/components/FilterBottomSheetWrapper";
import SortViewMainContent from "./SortViewMainContent";
import type { SortBy } from "./types";
import type { SortByDataType, SortOrderType } from "./types";

type TopicSortBottomSheetProps = {
	showModal: boolean;
	handleSheetClose: () => void;
	handleSortByChange: (type: SortBy) => void;
	data: SortByDataType[];
	selectedSortByItem?: SortByDataType;
	sortOrderType: SortOrderType;
};

const TopicSortBottomSheet = ({
	showModal,
	handleSheetClose,
	handleSortByChange,
	data,
	selectedSortByItem,
	sortOrderType,
}: TopicSortBottomSheetProps) => {
	return (
		<FilterBottomSheetWrapper
			showModal={showModal}
			handleSheetClose={handleSheetClose}
			title="Sort by"
			snapPoints={["50%", "80%"]}
		>
			<SortViewMainContent
				handleSortByChange={handleSortByChange}
				data={data}
				selectedSortByItem={selectedSortByItem}
				sortOrderType={sortOrderType}
			/>
		</FilterBottomSheetWrapper>
	);
};

export default TopicSortBottomSheet;
